module.exports = __webpack_public_path__ + "static/media/stretcher.acce810b.svg";